import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { ILoginCallbackRequest, ILoginCallbackResponse } from "src/api/types";
import { IAppContext } from "../withAppContext";
import withAxios, { IAxiosProps } from "../withAxios";

export default withAxios(
  class GoogleCallback extends React.Component<
    IAxiosProps & IAppContext & RouteComponentProps<any>
  > {
    public async componentDidMount() {
      const code = this.props.location.search
        .substring(1)
        .split("&")
        .filter((p) => /^code=/.test(p))
        .map((p) => decodeURIComponent(p.substring("code=".length)))[0];
      const data: ILoginCallbackRequest = {
        code,
      };
      const response = (
        await this.props.axios.post<ILoginCallbackResponse>(
          "sign-up/google/callback",
          data
        )
      ).data;
      console.log("response.user=-======>", response)
      if (response.user?.id) {
        this.props.removeNewUserDetails()
        this.props.userChanged(response.user);
        this.props.onChangeUserDetails({...response.user})
        this.props.changeIsNewUser(false);
      } else if (response.data?.email) {
        this.props.removeNewUserDetails()
        this.props.userChanged(response.data);
        this.props.onChangeUserDetails({...response.data})
        this.props.changeIsNewUser(true);
      }

   
      this.props.history.push("/");
    }

    public render() {
      return null;
    }
  }
);



// WEBPACK FOOTER //
// ./src/shared/components/Signup/GoogleCallback.tsx